if (!customElements.get('collapsible-text')) {
  customElements.define(
    'collapsible-text',
    class CollapsibleText extends HTMLElement {
      constructor() {
        super();
        this.content = this.querySelector('.collapsible-text__content');
        this.toggle = this.querySelector('.collapsible-text__toggle');
        this.showMore = this.querySelector('.collapsible-text__show-more');
        this.showLess = this.querySelector('.collapsible-text__show-less');
        this.expanded = false;

        if (this.toggle) {
          this.toggle.addEventListener('click', this.handleToggle.bind(this));
        }

        this.checkOverflow();
        window.addEventListener('resize', this.checkOverflow.bind(this));
      }

      checkOverflow() {
        if (!this.content || !this.toggle) return;
        const isOverflowing = this.content.scrollHeight > this.content.clientHeight;
        this.toggle.style.display = isOverflowing || this.expanded ? '' : 'none';
      }

      handleToggle() {
        this.expanded = !this.expanded;
        this.content.classList.toggle('expanded', this.expanded);
        this.showMore.classList.toggle('hidden', this.expanded);
        this.showLess.classList.toggle('hidden', !this.expanded);
      }
    }
  );
}
